// submitTracking.ts — funnel tracking klik "Pesan" (best-effort, tak boleh gagalkan order)
import { fireFunnelMetaEvent, fireFunnelGoogleEvent, fireFunnelTiktokEvent, fireFunnelSnackEvent } from '../../services/formViewerService/funnelEvents';
import { pickPlatformPixelIds } from '../../services/formViewerService/pixelOptimization';
import { fireGoogleAdsConversion } from '../../../../utils/googleAdsConversion';

interface TrackingCtx {
  form: any; currentCombination: any; quantity: number; identifier: string;
  formPagePixels: any; formPagePixelConfigs: any;
}

// Peta baku: klik pesan LOLOS validasi = InitiateCheckout (1x per sesi form).
// Gagal tracking tidak boleh menggagalkan order — semua dibungkus try.
export function fireSubmitTracking(ctx: TrackingCtx): void {
  const { form, currentCombination, quantity, identifier, formPagePixels, formPagePixelConfigs } = ctx;
  try {
    const ids = formPagePixels?.ids || [];
    if (ids.length > 0) {
      const unit = currentCombination?.sellingPrice ?? form?.productPrice ?? 0;
      fireFunnelMetaEvent(ids, 'InitiateCheckout', {
        content_ids: [form?.slug || identifier],
        content_name: form?.title || 'Form',
        value: unit * (quantity || 1),
      }, `px_funnel_ic_${form?.id || identifier}`);
    }
  } catch { /* abaikan */ }
  // Mid-funnel platform lain (Google/TikTok/Snack) — daftar dari configs
  // yg sama (sudah termasuk pixel optimasi brand). Gagal tracking abaikan.
  try {
    const cfgs = formPagePixelConfigs || [];
    const unit2 = currentCombination?.sellingPrice ?? form?.productPrice ?? 0;
    const val2 = unit2 * (quantity || 1);
    const base2 = {
      content_ids: [form?.slug || identifier],
      content_name: form?.title || 'Form',
      value: val2,
    };
    const fid = form?.id || identifier;
    fireFunnelGoogleEvent(pickPlatformPixelIds(cfgs, 'google'), 'begin_checkout', { value: val2 }, `px_funnel_gic_${fid}`);
    // Google Ads (AW-) conversion snippet — di-fire DI SINI (klik kirim), bukan saat load.
    fireGoogleAdsConversion(form, 'ic', { value: val2, dedupeKey: fid });
    fireFunnelTiktokEvent(pickPlatformPixelIds(cfgs, 'tiktok'), 'InitiateCheckout', base2, `px_funnel_ttic_${fid}`);
    fireFunnelSnackEvent(pickPlatformPixelIds(cfgs, 'snack'), 'START_CHECKOUT', base2, `px_funnel_snic_${fid}`);
  } catch { /* abaikan */ }
}
